/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { memo } from "react";
import { useDataTableContext } from "../store/DataTableProvider";
import { QuickActionRunRowWorkflowTable } from "../layout/DataTableQuickActionBar/QuickActionRunRow";
import { GridApi } from "ag-grid-community";
import { DataTableRowData } from "../layout/DataTable";
import { isWorkflowTable } from "../store/DataTableProvider.helpers";
import { RunStatusIcon } from "components/RunStatusIcon/RunStatusIcon";

const styles = {
  root: css`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
    padding: 0px 11px;
    background-color: inherit;
    gap: 2px;
  `,
};

interface CellRendererQuickActionsWorkflowTableProps {
  rowId: string;
  gridApi: GridApi<DataTableRowData> | undefined;
  tableId: string;
  readOnly?: boolean;
}

export const CellRendererQuickActionsWorkflowTable = memo(
  function CellRendererQuickActionsWorkflowTable({
    rowId,
    gridApi,
    tableId,
    readOnly,
  }: CellRendererQuickActionsWorkflowTableProps) {
    const row = useDataTableContext((s) => {
      const table = s.tables
        .filter(isWorkflowTable)
        .find((table) => table.id === tableId);
      return table?.rows.find((row) => row.id === rowId);
    });
    const columns = useDataTableContext((s) => {
      const table = s.tables.find((table) => table.id === tableId);
      return table?.columns;
    });

    if (columns === undefined || row === undefined) {
      return null;
    }

    return (
      <span css={styles.root}>
        {row.run === null ? (
          <QuickActionRunRowWorkflowTable
            readOnly={readOnly}
            tableId={tableId}
            rowId={row.id}
            gridApi={gridApi}
          />
        ) : (
          <RunStatusIcon
            runId={row.run.id}
            runStatus={row.run.status}
            runCreated={row.run.date_created}
          />
        )}
        {/*
        {row.task !== null && !isTerminalTaskStatus(row.task.status) ? (
          <QuickActionCancelTask
            readOnly={readOnly}
            tableId={tableId}
            rowId={row.id}
          />
        ) : (
          <QuickActionDeleteRow
            readOnly={readOnly}
            tableId={tableId}
            rowId={row.id}
          />
        )}

        <QuickActionCopyRow
          readOnly={readOnly}
          tableId={tableId}
          rowId={row.id}
        />

        <QuickActionToggleRowJoinable
          readOnly={readOnly}
          tableId={tableId}
          rowId={row.id}
          isJoinable={row.joinable}
        /> */}
      </span>
    );
  },
);
